module.exports = __webpack_public_path__ + "static/media/netflix.262e5be1.png";